export default __webpack_public_path__ + "static/media/a4h-video.4ffcb86b.mp4";